import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { storeName as projectModelStore } from '../../redux/models/project.model';
import { storeName as layoutModelStore } from '../../redux/models/layout.model';
import { CONTENT_KEY } from '../../commons/constants';

export const useLayout = (): void => {
  const contentActiveKey = useSelector((state) => state[projectModelStore].contentActiveKey);
  const layoutModelDispatch = useDispatch()[layoutModelStore];

  useEffect(() => {
    let showRightPanel = false;
    if (
      [CONTENT_KEY.LOCATION.key, CONTENT_KEY.AMENITIES.key, CONTENT_KEY.SITEPLAN.key].some(
        (item) => item === contentActiveKey
      )
    ) {
      // reset right panel when change page
      showRightPanel = true;
    }

    layoutModelDispatch.setShowRightPanel(showRightPanel);
  }, [contentActiveKey]);

  return useMemo(() => null, []);
};
